import { render, staticRenderFns } from "./AgeVerificationSetup.vue?vue&type=template&id=3415258e&scoped=true&"
import script from "./AgeVerificationSetup.vue?vue&type=script&lang=ts&"
export * from "./AgeVerificationSetup.vue?vue&type=script&lang=ts&"
import style0 from "./AgeVerificationSetup.vue?vue&type=style&index=0&id=3415258e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3415258e",
  null
  
)

export default component.exports